module.exports = __webpack_public_path__ + "media/images/icon_star-76cfb44f86a125913ddb0d037a04aa76.png";